import http from '@/http-common'
import SmetaTab from '@/components/SmetaTab.vue'
import RequestModal from '@/components/RequestSportModal.vue'
import FileDocument from '../../components/FileDocument.vue'
import InputGroupForm from "@/components/InputGroupForm.vue";

export default {
  name: 'SmetaPage',
  components: {SmetaTab, RequestModal, FileDocument, InputGroupForm},
  props: {
    percent: {
      type: Number,
      default: 1
    },
    editItem: {
      type: Object,
      default: null
    },
    smetaObject: {
      type: Object,
      default: null
    },
    heldValue: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      fileTypes: '.pdf,.xls,.xlsx,.doc,.docx',
      smetaEkp: {},
      smetaData: {},
      confirm_dialog: false,
      confirm_dialog2: false,
      request_dialog: false,
      dfileName: '',
      downloadFileLink: '',
      columnsDet: [
        {key: 'cost', label: 'Статьи расхода'},
        {key: 'norma', label: 'Цена (норма)'},
        {key: 'summa', label: 'Цена (смета)'},
        {key: 'countPeople', label: 'Кол-во участ/шт'},
        {key: 'countDays', label: 'Кол-во дней/часов'},
        {key: 'itogoNorma', label: 'Итого (норма)'},
        {key: 'itogoSmeta', label: 'Итого (смета)'},
        {key: 'returnSumm', label: 'Возврат'},
        {key: 'comment', label: 'Расшифровка'},
        {key: 'checkDocument', label: 'Оплачено'},
        {key: 'edit_field', label: ''},
      ],
      filter2: null,
      validSmeta: {
        manager: true,
        resp: true,
        summaSmeta: true,
        normaSmeta: true,
        form: true
      },
      modalLoadOpened: false,
      docSmetaOpened: false
    }
  },
  created() {
    this.validSmeta.manager = true;
    this.validSmeta.resp = true;
    this.validSmeta.form = true;
    this.validSmeta.normaSmeta = true;
    this.downloadFileLink = '';
    this.smetaEkp = JSON.parse(JSON.stringify(this.smetaObject));
    this.loadSmeta(this.editItem.id);
    //this.loadCosts();
  },
  watch: {
    smetaEkp: function (val) {
      if (val !== false) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    loadSmeta(id) {
      let vm = this;
      this.modalLoadOpened = true;
      http.get('/smeta/' + id)
      .then((response) => {
        if (response.data && response.data !== "") {
          vm.smetaEkp = response.data;
          vm.smetaEkp.details.forEach(function (item) {
            item.itogoNorma = item.norma * item.countPeople * item.countDays;
          })
          vm.smetaData = JSON.parse(JSON.stringify(this.smetaEkp));
        } else {
          vm.cleanSmeta();
        }
      })
      .catch((error) => console.log(error.message))
      .finally(() => this.modalLoadOpened = false);
    },
    cleanSmeta() {
      for (let key in this.smetaEkp) {
        if (typeof this.smetaEkp[key] == 'string') {
          this.smetaEkp[key] = '';
          this.smetaData[key] = ''
        } else {
          this.smetaEkp[key] = null;
          this.smetaData[key] = null
        }
      }
    },
    addSmetaRow() {
      let det = {
        id: 0,
        cost_id: 0,
        countPeople: 1,
        countDays: 1,
        summa: 0,
        comment: ''
      };
      if (!this.smetaEkp.details) {
        this.smetaEkp.details = [];
      }
      this.smetaEkp.details.push(det);
    },
    saveSmeta() {
      this.checkSmeta();
      this.smetaEkp.ekp_id = this.editItem.id;
      this.modalLoadOpened = true;
      let vm = this;
      vm.modalLoadOpened = true;
      if (this.validSmeta.form) {
        http.post('/smeta', this.smetaEkp)
        .then((response) => {
          let dataR = response.data;
          if (dataR.ekp_id > 0) {
            vm.$emit('changeSummaSmeta', dataR.summaSmeta, dataR.summaReturn);
            //this.selectItem(this.item);
          } else {
            alert(error.response.message)
          }
          vm.$emit('closeDialog');
        })
        .catch((error) => {
          if (error.response.status === 403) {
            alert("Нет прав!")
          } else {
            alert(error.response.data)
          }
        })
        .finally(() => {
          this.modalLoadOpened = false;
        });
      } else {
        vm.modalLoadOpened = false;
      }
    },
    checkSmeta() {
      let vm = this;
      this.validSmeta.manager = true;
      this.validSmeta.resp = true;
      this.validSmeta.form = true;

      if (!this.smetaEkp.manager_id || this.smetaEkp.manager_id <= 0) {
        this.validSmeta.manager = false;
        this.validSmeta.form = false;
      }
      if (!this.smetaEkp.resp_id || this.smetaEkp.resp_id <= 0) {
        this.validSmeta.resp = false;
        this.validSmeta.form = false;
      }

      // if (this.smetaEkp.orderDate) {
      //     if (this.editItem.dateEnd) {
      //         if (this.smetaEkp.orderDate > this.editItem.dateEnd) {
      //             this.validSmeta.orderDate = false;
      //             this.validSmeta.form = false;
      //         }
      //     } else {
      //         if (this.smetaEkp.orderDate > this.editItem.dateBegin) {
      //             this.validSmeta.orderDate = false;
      //             this.validSmeta.form = false;
      //         }
      //     }
      // }

      this.smetaEkp.details.some(function (rec) {
        if (rec.norma > 0 && rec.norma < rec.summa) {
          vm.validSmeta.normaSmeta = false;
          vm.validSmeta.form = false;
          return;
        }
      });

      if (!this.validSmeta.summaSmeta) {
        this.validSmeta.form = false;
      }
    },
    showConfirmMess() {
      this.confirm_dialog = !this.confirm_dialog;
    },
    closeEvent() {
      let vm = this;
      let idEkp = this.smetaEkp.ekp_id;
      http.post('/ekp/close/' + idEkp)
      .then((response) => {
        vm.editItem.held = response.data;
        vm.$emit('changeHeld', response.data)
      })
      .catch((error) => console.log(error.message));
    },
    showTempBtn() {
      this.$emit('showTempBtn');
    },
    exportSmeta() {
      this.checkSmeta();
      let vm = this;
      if (vm.validSmeta.form) {
        vm.downloadFileLink = '';
        if (this.smetaEkp.details && this.smetaEkp.details.length > 0) {
          http.post('/smeta/excel', this.smetaEkp,
              {
                responseType: 'blob'
              }
          )
          .then((response) => {
            console.log('Excel: ' + response.data)
            // Создаем Blob из полученных данных
            const blob = new Blob([response.data], {
              type: 'application/vnd.ms-excel' // MIME тип для .xls файлов
            });

            // Создаем ссылку для скачивания
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Смета_' + vm.editItem.id + '.xls';

            // Добавляем ссылку в DOM, кликаем и удаляем
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Очищаем URL объект
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => console.log(error));
        } else {
          alert("Смета пустая!");
        }
      }
    },
    downloadFile() {
      let vm = this;
      http.get(this.downloadFileLink,
          {
            responseType: 'arraybuffer',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/pdf'
            }
          }
      ).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', vm.dfileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
    closeDialog() {
      if (this.checkSmetaUpdate()) {
        this.$emit('closeDialog');
      } else {
        this.confirm_dialog2 = !this.confirm_dialog2;
      }
    },
    showPeopleDialog(i) {
      this.$emit('showPeople', i);
    },
    checkSmetaUpdate() {
      let vm = this;
      let fl = true;
      for (let key in vm.smetaEkp) {
        if (typeof this.smetaEkp[key] == 'object') {
          let objlist = vm.smetaEkp ? vm.smetaEkp[key] : [];
          let objlist2 = vm.smetaData ? vm.smetaData[key] : [];
          if (Array.isArray(objlist)) {
            if (Array.isArray(objlist2) && objlist2.length !== objlist.length) {
              fl = false;
            } else {
              objlist.forEach(function (obj) {
                if (!objlist2 || !Array.isArray(objlist2)) {
                  fl = false
                } else {
                  const index = objlist2.map(e => e.id).indexOf(obj.id);
                  for (let key2 in obj) {
                    if (obj[key2] !== objlist2[index][key2]) {
                      fl = false;
                      break;
                    }
                  }
                }
              })
            }
          }
        } else {
          if (vm.smetaEkp[key] !== vm.smetaData[key]) {
            fl = false
          }
        }
        if (!fl) {
          break;
        }
      }
      return fl;
    },
    showRequestBtn() {
      this.request_dialog = !this.request_dialog;
    },
    closeModal() {
      this.docSmetaOpened = false
    },
    showDocSmetaBtn() {
      this.docSmetaOpened = !this.docSmetaOpened;
    },
    saveDocSmeta() {
      this.$refs.FileDocuments.saveDocuments();
    }
  },
  computed: {
    allSumma() {
      let det = this.smetaEkp.details;
      let summ = 0;
      let vm = this;
      if (det) {
        det.forEach(function (x) {
          if (x.usePercent) {
            let p = 1 + (vm.percent / 100);
            summ += parseFloat(x.summa * x.countPeople * x.countDays * p);
          } else {
            summ += parseFloat(x.summa * x.countPeople * x.countDays);
          }
        })
        summ = summ.toFixed(2);

        vm.validSmeta.summaSmeta = summ <= vm.editItem.summ;
      }
      return summ;
    }
  }
}
